import { render } from "./CompanyInformationFormLocked.vue?vue&type=template&id=308b4d62&scoped=true"
import script from "./CompanyInformationFormLocked.vue?vue&type=script&lang=js"
export * from "./CompanyInformationFormLocked.vue?vue&type=script&lang=js"

import "./CompanyInformationFormLocked.vue?vue&type=style&index=0&id=308b4d62&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308b4d62"]])

export default __exports__